module.exports = __webpack_public_path__ + "static/media/saddest.93ddc2fa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/smileys/saddest.svg
// module id = 163
// module chunks = 0